<template>
  <div id="app">
    <b-container>
      <NavBar v-if="isAuthenticated"/>
      <TopAlert />
      <router-view/>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import NavBar from '@/components/NavBar.vue'
import TopAlert from '@/components/TopAlert.vue'

export default {
  name: 'app',
  components: {
    NavBar,
    TopAlert
  },
  computed: {
    ...mapGetters(['isAuthenticated'])
  }
}
</script>

<style lang="stylus">

</style>
